import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// フォント・アイコンはビルド時に同梱する。実行中に外部CDNを取りに行かない。
// 日本語フォントは文字の範囲ごとに細かく分かれた版を使う。画面に出ている文字の分だけを読み込むので、
// 全文字入りの1ファイル（1ウェイト約1MB）を丸ごと取りに行くより初回表示が軽い。
import '@fontsource/noto-sans-jp/500.css';
import '@fontsource/noto-sans-jp/700.css';
// アイコンは画面で使うものだけに絞ったフォントを同梱する（全アイコン入りは約4.5MBあり、初回表示が重い）
import './styles/icons.css';
import './styles/app.css';

import { App } from './App.js';
import { ClockProvider } from './state/clock.js';
import { UiProvider } from './state/ui.js';

/**
 * 患者表示情報はメモリ上だけで扱う。
 * localStorage・IndexedDB・Service Worker Cache へ保存しない（実装プラン 5章）。
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { gcTime: 0, staleTime: 0, retry: 1, refetchOnWindowFocus: true },
    mutations: { retry: 0 },
  },
});

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ClockProvider>
        <UiProvider>
          <App />
        </UiProvider>
      </ClockProvider>
    </QueryClientProvider>
  </StrictMode>,
);
